import { ChatPage } from './../chat/chat.page';
import { environment } from 'src/environments/environment';
import { ActivatedRoute, Router } from '@angular/router';
import { SubSink } from 'subsink';
import { Component, OnInit, NgZone } from '@angular/core';
import { CalendarOptions } from '@fullcalendar/angular';
import { PopoverController, ModalController, ToastController } from '@ionic/angular';
import { ApiService } from 'src/app/services/api/api.service';
import { PublicApiService } from 'src/app/services/public/public-api.service';
import SwiperCore, { Autoplay, Pagination, Navigation, Thumbs } from 'swiper';
import { AccountInformationService } from 'src/app/services/account-information/account-information.service';
import * as moment from 'moment';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { DatePipe } from '@angular/common';
SwiperCore.use([Autoplay, Pagination, Navigation, Thumbs]);


@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.page.html',
  styleUrls: ['./user-profile.page.scss'],
})
export class UserProfilePage implements OnInit {
  subscription = new SubSink();
  userRes: any;
  bucket_url: string = environment.s3_bucket_url;
  profilePlaceholder: string = '/assets/images/profile-placeholder.png';
  coverPlaceholder: string = '/assets/images/cover-placeholder.jpg';
  user: any;
  calendarVisible = true;
  calendarOptions: CalendarOptions;
  video_url: string = '';
  paymentHandler: any = null;
  // columnSize: Number = 6.5;
  columnSize: Number = 8.5;
  isValid = false;
  user_music: boolean = false;
  first_music: any = [];
  dateEvents: any = [];
  isEventsModalOpen: boolean = false;
  totalFollowers: 0;
  isGalleryModalOpen: boolean = false;
  gallery_photos: any = [];
  thumbsSwiper: any;

  showMap: boolean = true;
  showSpecials: boolean = false;
  showCalendarMobile: boolean = false;

  display : any;
  center: google.maps.LatLngLiteral = {lat: 24, lng: 12};
  zoom = 4;
  markerOptions: google.maps.MarkerOptions = {
    draggable: false,
    icon: 'https://cll-stage.s3.us-east-2.amazonaws.com/map-icons/travel.png'
  };
  markerPositions: google.maps.LatLngLiteral[] = [];
  userEvents: any = [];
  moment = moment;

  api_key: string = environment.google_calendar_api_key;

  google_calendar_url: string = '';
  googleCalendarEvents: any = [];

  date_pipe = new DatePipe('en-us');
  isSyncClicked: boolean = false;

  response_message: string = '';
  showGoogleSyncSpinner: boolean = false;
  isSignedIn: boolean = false;

  private httpClient2: HttpClient;       //For calling API without interceptor

  constructor(
    private apiService: ApiService,
    private route: ActivatedRoute,
    private router: Router,
    private modalCtrl: PopoverController,
    private publicService: PublicApiService,
    private accInfoService: AccountInformationService,
    private http: HttpClient,
    private toast: ToastController,
    handler: HttpBackend
  ) {
    this.httpClient2 = new HttpClient(handler);       //For calling API without interceptor
  }

  async ionViewWillEnter(){
    await this.getUserData();
    await this.getUserEvents();
    this.getAccountInformation();
    // await this.loadGapi();
    // gapi.load('client:auth2', this.initClient.bind(this));
  }
  ionViewWillLeave(){
    this.subscription.unsubscribe();
    this.isSyncClicked = false;
  }

  async ngOnInit() {

  }

  upcomingEvents() {
    let user_id =  JSON.parse(localStorage.getItem('user_profile')).id;

    this.apiService.get('events/upcomingProfileEvents/' + user_id).subscribe(
      (res: any []) => {
        this.userEvents = res['data'];
        this.dateEvents = res['data'];
        this.isEventsModalOpen = true;
        if (this.userEvents.length > 0) {
          this.calendarOptions.events = this.userEvents.map((evt) => {
            return {
              title: evt.event_title,
              date: evt.event_date,
              eventId: evt.id,
            };
          });
        }
      })
  }



  ionViewDidEnter(){
    this.showCalendar();
  }

  getGoogleCalendarEvents() {
    this.showGoogleSyncSpinner = true;
    this.subscription.sink = this.httpClient2.get(`https://content.googleapis.com/calendar/v3/calendars/${this.google_calendar_url}/events?key=${this.api_key}`).subscribe(
      (res: any) => {
        this.showGoogleSyncSpinner = false;
        this.isSyncClicked = true;
        // console.log("google cal events => ",res.items);
        this.googleCalendarEvents = res.items.map(element => {
          return {
            event_title: element.summary,
            event_date: element.start?.dateTime ? this.date_pipe.transform(element.start.dateTime,'yyyy-MM-dd') : this.date_pipe.transform(element.start.date,'yyyy-MM-dd'),
            event_end_date: element.end?.dateTime ? this.date_pipe.transform(element.end.dateTime,'yyyy-MM-dd') : this.date_pipe.transform(element.end.date,'yyyy-MM-dd'),
            event_id: element.id,
            event_start_time: element.start?.dateTime ? this.date_pipe.transform(element.start.dateTime,'hh:mm:ss') : null,
            event_end_time: element.end?.dateTime ? this.date_pipe.transform(element.end.dateTime,'hh:mm:ss') : null,
            event_html_link: element.htmlLink
          }
        });
        // console.log("google events parsed => ",this.googleCalendarEvents);
        // console.log("google events calendar options before ==> ",this.calendarOptions.events);
        this.userEvents = this.userEvents.concat(this.googleCalendarEvents);
        this.calendarOptions.events = this.userEvents.map((evt) => {
          return {
            title: evt.event_title,
            date: evt.event_date,
            eventId: evt.id,
          };
        });
        // console.log("google events calendar options after ==> ",this.calendarOptions.events);
      }, (error) => {
        this.showGoogleSyncSpinner = false;
        this.isSyncClicked = false;
        this.response_message = "Please make sure your email is correct and your google calendar is marked as public."
        this.presentErrorToast(this.response_message);
      });
  }

  async presentErrorToast(res_message) {
    const toast = await this.toast.create({
      header: 'Failed',
      color: 'danger',
      message: res_message,
      position: 'top',
      duration: 3000,
    });
    await toast.present();
  }

  getAccountInformation() {
    this.subscription.sink = this.accInfoService.getAccountInfo().subscribe(
      (res: any) => {
        // console.log("account info data => ", res);
        this.google_calendar_url = res.google_calendar_url;
      }, (error) => {
        console.log(error);
      })
  }

  onWillDismiss(e){
    this.isEventsModalOpen = false;
    this.isGalleryModalOpen = false;
  }

  closeModal(){
    this.isEventsModalOpen = false;
    this.isGalleryModalOpen = false;
  }

  showCalendar() {
    const angThis = this;
    this.calendarOptions = {
      height: '100%',
      headerToolbar: {
          left: 'prev',
          center: 'title',
          right: 'next'
      },
      initialView: 'dayGridMonth',
      initialDate: new Date(),
      eventDisplay: 'list-item',
      eventClick(arg) {
        angThis.getDateEvents(arg.event.startStr);
      },
    };
  }

  async getUserData(){
    // let id = this.route.snapshot.paramMap.get('id');
    this.subscription.sink = this.apiService.get('user-profile').subscribe(
      (res: any[]) => {
        this.userRes = res['data'];
        this.user = res['user'];
        // this.columnSize = (this.userRes?.account_type?.id == 3 || this.userRes?.account_type?.id == 5) ? 6.5 : 8.5;
        this.video_url = (this.userRes?.user_account_information?.youtube_video_url) ? this.publicService.getId(this.userRes?.user_account_information?.youtube_video_url) : 'error';
        this.user_music = this.userRes?.user_musics.length > 0 ? true : false;
        this.first_music = this.userRes?.user_musics?.length > 0 ? this.userRes?.user_musics[0] : [];
        this.totalFollowers = res['totalFollowers'] ? res['totalFollowers'] : 0;
        // this.user = res['user'];
        if (this.userRes?.user_contact_information) {
          this.markerPositions.push({
            lat: Number(this.userRes?.user_contact_information?.lat),
            lng: Number(this.userRes?.user_contact_information?.long)
          });
          this.display = {
            lat: Number(this.userRes?.user_contact_information?.lat),
            lng: Number(this.userRes?.user_contact_information?.long),
          };
          this.center = {
            lat: Number(this.userRes?.user_contact_information?.lat),
            lng: Number(this.userRes?.user_contact_information?.long),
          };
        }

        if (this.userRes?.account_type_id == 1) {
          this.markerOptions = {
            draggable: false,
            icon: '../../../assets/icons/bands-marker.png',
          };
        } else if (this.userRes?.account_type_id == 2) {
          this.markerOptions = {
            draggable: false,
            icon: '../../../assets/icons/comedians-marker.png',
          };
        } else if (this.userRes?.account_type_id == 3) {
          this.markerOptions = {
            draggable: false,
            icon: '../../../assets/icons/foodtruck-marker.png',
          };
        } else if (this.userRes?.account_type_id == 4) {
          this.markerOptions = {
            draggable: false,
            icon: '../../../assets/icons/user-marker.png',
          };
        } else if (this.userRes?.account_type_id == 5) {
          this.markerOptions = {
            draggable: false,
            icon: '../../../assets/icons/venues-marker.png',
          };
        }
      }
    );
  }

  playTrack(container_class){
    document.querySelectorAll("."+container_class+" .play").forEach(elem => elem.classList.add("hidden"));
    document.querySelectorAll("."+container_class+" .pause").forEach(elem => elem.classList.remove("hidden"));
    const video = document.getElementById(container_class) as HTMLVideoElement | null;

    if (video != null) {
      video.play();
    }
  }

  pauseTrack(container_class){
    document.querySelectorAll("."+container_class+" .play").forEach(elem => elem.classList.remove("hidden"));
    document.querySelectorAll("."+container_class+" .pause").forEach(elem => elem.classList.add("hidden"));
    const video = document.getElementById(container_class) as HTMLVideoElement | null;

    if (video != null) {
      video.pause();
    }
  }

  goToUserArchiveVideos(id){
    let userId = btoa(id)!;
    // let userId = this.route.snapshot.paramMap.get('userId');
    this.router.navigate(['account-videos/'+userId]);
  }
  async openChatModal(event){
    const modal = await this.modalCtrl.create({
      component: ChatPage,
      event,
      componentProps: { user_id: atob(this.route.snapshot.paramMap.get('userId'))! },
      cssClass: 'profile-chat-popover'
    });
    modal.present();
    await modal.onWillDismiss();
  }


  async viewUserGallery(){
    // const modal = await this.galleryModal.create({
    //   component: GalleryViewerPage,
    //   componentProps: { user_id: atob(this.route.snapshot.paramMap.get('userId'))! },
    //   cssClass: 'profile-gallery-modal'
    // });
    // modal.present();
    // await modal.onWillDismiss();


      // const modal = await this.galleryModal.create({
      //   component: GalleryViewerPage,
      //   componentProps: { user_id: atob(this.route.snapshot.paramMap.get('userId'))! },
      //   cssClass: 'profile-gallery-modal'
      // });
      // modal.present();
      // await modal.onWillDismiss();
      this.isGalleryModalOpen = true;
      // console.log("show gallery modal");
      let user_id = JSON.parse(localStorage.getItem("user_profile")).id;
      this.subscription.sink = this.apiService.get('users/getProfileGallery/' + user_id).subscribe(
        (res: any[]) => {
          this.gallery_photos = res;
        }
      );
  }


  toggleMap() {
    this.showMap = !this.showMap;
  }

  toggleSpecials() {
    this.showSpecials = !this.showSpecials;
  }

  toggleCalendarMobile() {
    this.showCalendarMobile = !this.showCalendarMobile;
    this.showMobileCalendar();
  }

  showMobileCalendar() {
    this.getUserEvents();
    const angThis = this;
    this.calendarOptions = {
      height: 'auto',
      headerToolbar: {
        left: 'prev',
        center: 'title',
        right: 'next'
      },
      contentHeight: 1400,
      initialView: 'dayGridMonth',
      initialDate: new Date(),
      eventDisplay: 'list-item',
      eventClick(arg) {
        angThis.getDateEvents(arg.event.startStr);
      },
    };

  }

  getDateEvents(date){
    let filtered_google_events = [];
    // console.log("before => ",this.googleCalendarEvents);
    filtered_google_events = this.googleCalendarEvents.filter((element)=>{
      return element.event_date == date;
    });
    // console.log("after => ",filtered_google_events);
    let user_id = this.accInfoService.getUserProfile().id;
    this.apiService.get('events/eventsOfProfileByDate/' + user_id + '/' + date).subscribe(
      (res: any[]) => {
        this.dateEvents = res['data'];
        this.dateEvents = this.dateEvents.concat(filtered_google_events);
        this.isEventsModalOpen = true;
        // console.log("user events on date ========>", this.dateEvents);
    });
  }

  openGoogleCalendarEvent(event){
    window.open(`${event?.event_html_link}`, '_system', 'location=yes');
  }

  getUserEvents(){
    let user_id = this.accInfoService.getUserProfile().id;
    this.userEvents = [];
    this.apiService.get('events/getProfileEvents/' + user_id).subscribe(
      (res: any []) => {
        // console.log("events", res);
        this.userEvents = res['data'];
        if (this.userEvents.length > 0) {
          this.calendarOptions.events = this.userEvents.map((evt) => {
            return {
              title: evt.event_title,
              date: evt.event_date,
              eventId: evt.id,
            };
          });
        }
      })
  }
}
